"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerFunctionFilter = void 0;
/**
 * Default function filter to not add functions with name starting with "c_0x"
 * to the Router. These functions are added by the "solidity-coverage" library
 * during coverage tests when instrumenting the contracts.
 */
const routerFunctionFilter = (fnName) => !fnName.startsWith('c_0x');
exports.routerFunctionFilter = routerFunctionFilter;
//# sourceMappingURL=router-function-filter.js.map